import { render, staticRenderFns } from "./ProjectAssetReviewManager.vue?vue&type=template&id=6075d1b6"
import script from "./ProjectAssetReviewManager.vue?vue&type=script&lang=js"
export * from "./ProjectAssetReviewManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports